
<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fw-bold mb-0">
    {{ 'TEAM.TITLE' | translate }}
  </h1>
  <button id="addNewTeam" class="btn btn-primary fw-bold bi-plus-lg" type="button" (click)="addNewTeam()">
    {{ 'TEAM.LIST.ADD_NEW_TEAM' | translate }}
  </button>
</div>

<div class="row mb-4">
  <div class="col-12">
    <div class="card shadow-sm border-0">
      <div class="card-body pt-3 p-0">
      @if (isLoading) {
        <div class="d-flex justify-content-center align-items-center p-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
          </div>
          <span class="ms-2">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
      } 
      @else {
        @if (teams && teams.length > 0) {
          <div class="table-responsive">
            <table class="table table-hover table-striped mb-0">
              <thead>
                <tr>
                  <th scope="col">{{ 'TEAM.DETAILS.NAME' | translate }}</th>
                  <th scope="col">{{ 'TEAM.DETAILS.TYPE' | translate }}</th>
                  <th scope="col">{{ 'TEAM.DETAILS.MANAGER' | translate }}</th>
                  <th scope="col">{{ 'TEAM.LIST.MEMBERS' | translate }}</th>
                  <th scope="col">{{ 'COMMON.ACTIONS' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (team of teams; track team.id) {
                  <tr>
                    <td>
                      <a [routerLink]="['/teams', team.id]" class=" text-decoration-none fw-bold">
                        {{ team.name }}
                      </a>
                    </td>
                    <td>
                      <span class="badge bg-secondary">
                        {{ team.teamType }}
                      </span>
                    </td>
                    <td>
                      @if (team.manager) {
                        <a [routerLink]="['/peoples', team.manager.id]" class="text-decoration-none">
                          <app-avatar [personOrPeople]="team.manager" size="normal" shape="circle" class="border-0"></app-avatar>
                        </a>
                      } @else {
                        <span class="text-muted fst-italic small ">{{ 'TEAM.DETAILS.NO_MANAGER' | translate }}</span>
                      }
                    </td>
                    <td>
                      <div class="d-flex align-items-center flex-wrap gap-1">
                        @if (team.peoples && team.peoples.length > 0){
                        <app-avatar [personOrPeople]="team.peoples" [grouped]="true" size="normal" shape="circle" class=" border-0"></app-avatar>
                        <span class="text-muted fst-italic small fw-bold">({{ team.peoples.length }})</span>
                        }
                        @else {
                          <span class="text-muted fst-italic small ">{{ 'TEAM.LIST.NO_MEMBERS' | translate }}</span>
                        }
                      </div>
                    </td>
                    <td>
                      <div class="btn-group" role="group">
                        <button title="{{ 'COMMON.EDIT' | translate }}" class="btn btn-outline-primary btn-sm rounded-pill border-0 me-1 editPerson" (click)="editTeam(team)">
                          <i class="bi bi-pencil-fill"></i>
                        </button>
                        <button title="{{ 'COMMON.DELETE' | translate }}" class="btn btn-outline-danger btn-sm rounded-pill border-0 me-1 deletePerson" (click)="confirmDelete(team)">
                          <i class="bi bi-trash-fill"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <p class="text-muted mb-0">{{ 'TEAM.LIST.NO_TEAMS' | translate }}</p>
        }
      }
      </div>
    </div>
  </div>
</div>


@if (showConfirmDialog) {
<app-confirm-dialog  
  [warningMessages]="warningMessagesConfirmDialog"
  (confirm)="handleConfirm($event)">
</app-confirm-dialog>
}


<div class="offcanvas offcanvas-end" tabindex="-1" id="teamFormContainer" aria-labelledby="teamFormLabel"
    [class.show]="showTeamForm">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="teamFormLabel">
      {{ teamToEdit ? ('TEAM.FORM.EDIT_TEAM' | translate) : ('TEAM.FORM.ADD_TEAM' | translate) }}
    </h5>
    <button type="button" class="btn-close text-reset" aria-label="Close" (click)="hideTeamForm()"></button>
  </div>
  <div class="offcanvas-body">
    @if (showTeamForm) {
      <app-team-form
        [teamToEdit]="teamToEdit"
        (formSubmitted)="handleFormSubmission($event)"
        (cancel)="onCancelForm()">
      </app-team-form>
    }
  </div>
</div>